<template>
  <Modal v-if="season && wasMounted" layout="main">
    <div class="slideshow">
      <MediaSlideshow :images="season.posters" :index="index" />
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'

import { socialUrl } from '@/util/helpers'
import Modal from '@/components/Modal'
import MediaSlideshow from '@/components/MediaSlideshow'

export default {
  name: 'SeasonGalleryOverlay',
  props: ['slug'],
  components: {
    Modal,
    MediaSlideshow
  },
  data() {
    return {
      index: 0,
      wasMounted: false
    }
  },
  computed: {
    ...mapGetters(['allSeasons']),
    season() {
      return this.findSeason(this.slug)
    }
  },
  methods: {
    findSeason(slugOrId) {
      return this.allSeasons.find((s) => [s._id, s.slug].includes(slugOrId))
    }
  },
  mounted() {
    const index = Number(this.$route.hash.replace('#', ''))
    if (index) {
      this.index = index - 1
    }
    this.wasMounted = true
  },
  metaInfo() {
    const title = `Saison ${this.season?.title || ''}`
    const image = socialUrl(this.season?.posters?.[0])
    const description = this.season?.claim

    return {
      title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'og:title', name: 'og:title', content: title },
        {
          vmid: 'og:description',
          name: 'og:description',
          content: description
        },
        { vmid: 'og:image', name: 'og:image', content: image },
        { vmid: 'twitter:title', name: 'twitter:title', content: title },
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: description
        },
        { vmid: 'twitter:image', name: 'twitter:image', content: image }
      ]
    }
  }
}
</script>

<style scoped>
.slideshow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
